import { Component, CUSTOM_ELEMENTS_SCHEMA, ViewChild, AfterViewInit } from '@angular/core';
import { LabourRatesGridComponent } from '../../components/labour-rates/labour-rates-grid/labour-rates-grid.component';
import { LabourRatesFiltersComponent } from '../../components/labour-rates/labour-rates-filters/labour-rates-filters.component';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { LabourRatesFilterForm } from '../../form-model/labour-rates-filter.form.model';
import { SharedDataService } from '../../services/shared-data.service';

@Component({
  selector: 'app-labour-rates',
  imports: [LabourRatesFiltersComponent, LabourRatesGridComponent, ReactiveFormsModule],
  templateUrl: './labour-rates.component.html',
  styleUrl: './labour-rates.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LabourRatesComponent implements AfterViewInit {
  @ViewChild(LabourRatesFiltersComponent) filterComponent!: LabourRatesFiltersComponent;
  filterFormGroup = this.formBuilder.group({
    labourRatesFilterForm: this.formBuilder.group<LabourRatesFilterForm>({} as LabourRatesFilterForm),
  });

  constructor(
    private formBuilder: FormBuilder,
    private sharedDataService: SharedDataService,
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      const savedFilters = this.sharedDataService.getLabourRatesFilterFormValue();

      // Subscribe to filter changes first
      this.filterFormGroup.controls.labourRatesFilterForm.valueChanges.subscribe((value) => {
        this.sharedDataService.setLabourRatesFilterFormValue({
          shopCode: value.shopCode ?? undefined,
          equipmentType: value.equipmentType ?? undefined,
          expiryDateType: value.expiryDateType ?? undefined,
          expiryDate: value.expiryDate ?? undefined,
          expiryDateFrom: value.expiryDateFrom ?? undefined,
          expiryDateTo: value.expiryDateTo ?? undefined,
          effectiveDateType: value.effectiveDateType ?? undefined,
          effectiveDate: value.effectiveDate ?? undefined,
          effectiveDateFrom: value.effectiveDateFrom ?? undefined,
          effectiveDateTo: value.effectiveDateTo ?? undefined,
        });
      });

      // Check if there are saved filters with actual values
      const hasSavedFilters = savedFilters && Object.keys(savedFilters).length > 0;

      if (hasSavedFilters) {
        // Filter out undefined values to prevent patching null into form controls
        const valuesToPatch = Object.entries(savedFilters)
          .filter(([_, value]) => value !== undefined)
          .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

        if (Object.keys(valuesToPatch).length > 0) {
          this.filterFormGroup.controls.labourRatesFilterForm.patchValue(valuesToPatch, { emitEvent: false });
          this.filterComponent.updateSelectedFiltersSection();
        }
      }

      // Always trigger initial load (either with saved filters or empty)
      this.filterFormGroup.controls.labourRatesFilterForm.controls.applyLabourRatesFilter?.setValue(true, { emitEvent: true });
    }, 0);
  }
}
